<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "NotificationCenter",
  created() {
    let vm = this;
    vm.loadInitial();

    clearInterval(vm.interval);

    vm.interval = setInterval(
      function() {
        vm.fetchNew().then(result => {
          if (
            result &&
            result.data &&
            result.data.success &&
            result.data.payload.length
          ) {
            if (
              !_.find(this.notifications, {
                NOTIFICATION_ID: result.data.payload[0].NOTIFICATION_ID
              })
            ) {
              vm.appendNew(result.data.payload);
              vm.indicator = true;
              vm.playSound();
            }
          }
        });
      }.bind(vm),
      10000
    );
  },
  data() {
    return {
      interval: null,
      indicator: false
    };
  },
  computed: {
    ...mapState("notifications", {
      notifications: s => s.notifications
    })
  },
  methods: {
    openNotification(item) {
      let vm = this,
          type = item.ENTITY_ID

      // Users
      if(type == 1) {
        vm.select({ USER_ID: item.ENTITY_ITEM_ID, vm})
      }
      // Class Approvals
      if (type == 4) {
        let mode = vm.$p(['ADMIN','MANAGER'],'or') ? "approve" : "edit"
        vm.one({
          id: item.ENTITY_ITEM_ID,
          mode: mode
        })        
      }

      if (type == 6) {
        vm.order({
          ORDER_ID: item.ENTITY_ITEM_ID
        })        
      }
    },

    ...mapActions("notifications", ["loadInitial", "fetchNew"]),
    ...mapMutations("notifications", ["appendNew"]),
    ...mapActions("users", ["select"]),
    ...mapActions("classes", ["one"]),
    ...mapActions("orders", { order: "one" }),
    playSound() {
      var audio = new Audio("assets/sounds/notification.mp3");
      audio.play();
    },
    clearIndicator() {
      this.indicator = false;
    }
  },
  destroyed() {
    let vm = this;
    clearInterval(vm.interval);
  }
};
</script>

<template>
  <div id="notifications" :class="{'indicator' : indicator}">
    <q-btn-dropdown icon="fa fa-bell" @click="clearIndicator()">
      <q-list link separator>
        <q-item v-if="notifications.length == 0" v-close-overlay>
          <q-item-side inverted icon="error outline" color="red" text-color="white"/>
          <q-item-main>
            <q-item-tile label>No Notifications Found.</q-item-tile>
          </q-item-main>
        </q-item>
        <q-item
          tag="label"
          v-for="(item,i) in notifications"
          :key="i"
          v-close-overlay
          @click.native="openNotification(item)"
        >
          <q-item-side>
            <q-icon name="info outline" color="blue"/>
          </q-item-side>
          <q-item-main>
            <q-item-tile label>{{item.MESSAGE}}</q-item-tile>
          </q-item-main>
        </q-item>
      </q-list>
    </q-btn-dropdown>
  </div>
</template>

<style lang="stylus">
#notifications {
  position: relative;
  margin-right: 10px;

  .q-item-label {
    white-space: nowrap;
  }

  > button {
    padding: 4px 7px;

    .q-btn-dropdown-arrow {
      display: none;
    }
  }

  &.indicator {
    &:before {
      content: '';
      border-radius: 20px;
      height: 10px;
      width: 10px;
      background: red;
      position: absolute;
      bottom: 3px;
      left: 25px;
      z-index: 2;
      animation: blink-animation 1s ease-in-out infinite;
    }
  }
}
</style>